export enum TranslationNamespace {
  COMMON = 'common',
  HOME = 'home',
  ABOUT = 'about',
  FAQ = 'faq',
  LOCATION = 'location',
  ARTICLES = 'articles',
  CAREERS = 'careers',
  DATACENTER = 'datacenter',
  TEACHERS = 'teachers',
  SIGN_UP = 'sign-up',
  CONTACT = 'contact',
  CUSTOMER_FORM = 'customer-form',
  NEWSLETTER = 'newsletter',
  SCHOOL_WORKSHOPS = 'school-workshops',
}
